<template>
  <div class="d-none" v-if="modalShow">
    <b-modal
      v-model="modalShow"
      class="confirmModal"
      ref="confirmModal"
      hide-header
      hide-footer
      no-close-on-backdrop
      centered
      body-class="p-4"
      @hidden="handleCloseModal"
    >
      <div class="text-center mt-3">
        <font-awesome-icon class="icon-alert" :icon="['fas', 'exclamation-circle']" />
        <p class="text-text" v-if="text">{{ text }}</p>
      </div>
      <div class="text-center mt-3">
        <b-button
          variant="outline-secondary"
          pill
          class="mr-2 px-4"
          @click="handleCloseModal"
        >
          {{ button.false.msg }}</b-button
        >
        <b-button variant="primary" :id="id" pill class="px-4" @click="handleOkModal">
          {{ button.true.msg }}</b-button
        >
      </div>
      <div class="text-center mt-2"></div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      required: false,
      type: String
    },
    id:{
      required:false,
      type:String
    },
    button: {
      required: false,
      type: Object,
      default: () => {
        return {
          true: {
            class: ["btn-success"],
            msg: "OK",
            id:["logout"]
          },
          false: {
            class: ["btn-danger"],
            msg: "Cancel"
          }
        };
      }
    }
  },
  data() {
    return {
      modalShow: false
    };
  },
  methods: {
    show() {
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    handleOkModal() {
      this.$emit("handler", true);
      this.modalShow = false;
    },
    handleCloseModal() {
      this.$emit("handler", false);
      this.modalShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmModal {
  width: auto;
}
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-header {
  font-size: 18px;
}
.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.25rem;
  word-wrap: break-word !important;
}
.text-sub {
  color: #afce38;
  font-size: 1.25rem;
  word-wrap: break-word !important;
}
.modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .btn-primary{
    background-color: var(--primary-color);
    border-color: var(--primary-color);
}
.icon-alert{
  font-size: 50px;
  margin: 10px 0;
  color: var(--primary-color);
}
</style>
